import React from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import '../Pages/services.css'
import Blogcard from './Blogcard'

export default function Services() {
  return (
    <div className="container fluid-md inline" >
      <Blogcard />
    </div>
  )
}
